module.exports = __webpack_public_path__ + "static/img/bg.a5313df.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/sakura/card/header/bg.png
// module id = 1AtN
// module chunks = 6